var dialog = require('../../dialog'),
	ajax = require('../../ajax'),
	progress = require('../../progress'),
	imagesLoaded = require('imagesloaded'),
	image = require('./image'),
	util = require('../../util'),
	variant = require('./variant');

function initializeEvents() {
	$(window).resize(function() {
		if( $(".enlarge-dialog:visible") ) {
			enlargeImageEvents.enlargeZoom();
		}
    });
	$("body").off("click",".enlarge").on("click",".enlarge", function(e){
		e.preventDefault();
		var $curObj = $(this);
		var param= {
			format: 'ajax',
			enlarge: "true"
		}
		var modalHeight = 700;
		var url = util.appendParamsToUrl($curObj.attr("data-url"),param);
		if($(window).width() < 1024) {
			modalHeight = "auto"
		}
		var $curthumnline = $curObj.closest('.enlarge-video-sec').next('.product-thumbnails');
		$.ajax({
			url: url,
			success: function(data) {
				var enlargeDlg =  dialog.create({
					target : "#enlargecontainer",
			        options:{
			            width: 1260,
			            height: modalHeight,
			            dialogClass : 'enlarge-dialog',
			            open: function() {
		                    $('.ui-widget-overlay').bind('click', function(){
		                        $('#enlargecontainer').dialog('close');
		                    });
		                    /* PXSFCC-4495_WCAG_Modal_focus_management */
		                	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
		                    	$(this).focus();
		                    });
		                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
							$('#enlargecontainer').find('.swatchanchor img').unveil(0,variant.pdpSwatchLazyLoad);
		                },
			            close: function() {
			            	$("body").removeClass("overflow-hidden");
			            	$("#wrapper").removeClass("hide-content");
							$("body").find(".zoomWindowContainer, .zoomContainer").remove();
			            	$(this).dialog('close');
			            	image.loadZoom();
							image.alternateImageSlider();
			            }
			         }
			     });
				$(enlargeDlg).children().remove();
				$(enlargeDlg).append(data);
				$(enlargeDlg).find('ul.swatches').not(".color").closest(".attribute ").remove();
				enlargeDlg.dialog("open");

				$("body").addClass("overflow-hidden");
				if(util.isMobile()) {
					$("#wrapper").addClass("hide-content");
				}
				
				imagesLoaded('.enlarge-right-sec').on('always', function() {
					enlargeImageEvents.enlargeHeightCalc();
				});
				imagesLoaded('.enlarge-container .product-variation-content').on('always', function() {
	       			image.lazyLoadImages($('.enlarge-container .product-variation-content').find('img'));
	   		    });
				enlargeImageEvents.enlargeHeroSlider();
				enlargeImageEvents.enlargeZoom();
				enlargeImageEvents.dialogEvents();
				enlargeImageEvents.rightSectionScrollbar();
				$("body").on("click",".dummy-close-icon",function(){
					enlargeDlg.dialog("close");
				});
				$("body").on("click",".dummy-slick-arrow",function(){
					if($(this).hasClass("dummy-slick-prev")) {
						$(enlargeDlg).find(".enlarge-hero-container").find(".slick-prev").trigger("click");
					} else if ($(this).hasClass("dummy-slick-next")) {
						$(enlargeDlg).find(".enlarge-hero-container").find(".slick-next").trigger("click");
					}
				});
				$(window).resize(function(){
					enlargeImageEvents.enlargeHeightCalc();
					enlargeImageEvents.rightSectionScrollbar();
					$(".ui-dialog-content:visible").each(function () {
		                $(this).dialog("option", "position", $(this).dialog("option", "position"));
		            });
				});
				if($('.enlarge-thumb-image .thumb').length > 0 && $curthumnline.find('.thumb').length > 0){
					var selectedbackimage = $curthumnline.find('.thumb.selected').find('img').data('lgimg')['hires'].split('default/')[1];
					$('.enlarge-thumb-image .thumb').each(function(index){
						var $thumbImg = $(this).find('img.productthumbnail');
						var hiResURL = $thumbImg.data('lgimg')['hires'].split('default/')[1];
						if(util.getViewPort().viewport == 'mobile') {
							$thumbImg.attr('src',$thumbImg.attr('data-mobile-src'));
						}
						else {
							$thumbImg.attr('src',$thumbImg.attr('data-desktop-src'));
						}
				    	if(hiResURL == selectedbackimage ){
				    		$(this).find('.thumbnail-link').trigger('click');
				    	}
				    });
				}
			}
		});
	});

	$("body").off("click",".enlarge-thumb-image .thumb a, .enlarge-hero-image .thumb .thumbnail-link ").on("click",".enlarge-thumb-image .thumb a, .enlarge-hero-image .thumb .thumbnail-link", function(e){
		e.preventDefault();
	});
}

var enlargeImageEvents = {
	setEnlargeMainImage: function (atts) {
		// Hide liveclicker video
		if ($(window).width() > 767) {
			$('#lc_player_box').hide();
			$('.enlarge-hero-image .thumb').first().find('.productthumbnail').show();
		}
		// Update the largeImg's primary image
		$('.enlarge-hero-image .thumb').first().find('.productthumbnail').attr({
			src: atts.hires,
			alt: atts.alt,
			title: atts.title,
		});
		// Include logic to generate a 404 productImage (if the image doesn't load)
		$('.enlarge-hero-image .thumb').first().find('.productthumbnail').on('error', function () {
			$(this).attr('src', window.product404Images.largeImage);
		});
		// Only update the hires image if the hires url is provided
		if (atts.hasOwnProperty('hires')) {
			// Update the zoom-image with the hi-res url
			$('.enlarge-hero-image thumb').first().find('.thumbnail-link').data('zoom-image',atts.hires);
			enlargeImageEvents.enlargeZoom();
		}

	},
	enlargeHeightCalc: function() {
		$(".enlarge-hero-image, .enlarge-hero-container, .enlarge-hero-container .thumb,.enlarge-hero-container .thumb a, .enlarge-hero-container .thumb a img").height("auto");
		if( $(window).width() < 1024 ) {
			var windowHeight = $(window).height();
			var rightSectionHeight = $(".enlarge-right-sec").height();
			var totalHeight = (windowHeight - rightSectionHeight) - 40 ;
			$(".enlarge-hero-image, .enlarge-hero-container, .enlarge-hero-container .thumb,.enlarge-hero-container .thumb a, .enlarge-hero-container .thumb a img").height(totalHeight);
		}

	},
	dialogEvents : function() {
		var $dialogContainer = $("#enlargecontainer");
		//enlargeImageEvents.updateContent($(this).data('href'), $(this));
		// click on swatch - should replace product content with new variant
		$dialogContainer.off('click', '.swatchanchor').on('click', '.swatchanchor', function(e) {
	        e.preventDefault();
	        if ($(this).parents('li').hasClass('unselectable')) {
	            return;
			}
	        var largeImg = $(this).data('lgimg') || $(this).find('>img').data('lgimg');
			if (largeImg) {
				enlargeImageEvents.updateContent($(this).data('href'), largeImg);
			}
	    });

	    // change drop down variation attribute - should replace product content with new variant
		$dialogContainer.off('change', '.variation-select').on('change', '.variation-select', function() {
	        if ($(this).val().length === 0) {
	            return;
	        }
	        var largeImg = $(this).data('lgimg') || $(this).find('>img').data('lgimg');
			if (largeImg) {
				enlargeImageEvents.updateContent($(this).data('href'), largeImg);
			}
		});
		// change thumb nail -- should replace main image with selected thumb nail images
		$dialogContainer.off('click', '.enlarge-thumb-image .thumbnail-link').on('click', '.enlarge-thumb-image .thumbnail-link', function() {
			var largeImg = $(this).data('lgimg') || $(this).find('> img').data('lgimg');
			enlargeImageEvents.setEnlargeMainImage(largeImg);
		});
	},
/**
 * @function updateContent
 * @description update the main image based on the href and <a> tag
 */
	updateContent : function(href, largeImg) {
	    var $pdpForm = $('.enlarge-dialog .pdpForm');
	    var qty = $pdpForm.find('input[name="Quantity"]').first().val();
	    var params = {
	        Quantity: isNaN(qty) ? '1' : qty,
	        enlarge: "true",
	        productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
		};
		//this.setEnlargeMainImage(largeImg);
		var mainImageHeight = $(".enlarge-hero-container").height();
	    ajax.load({
	        url: util.appendParamsToUrl(href, params),
	        target: $('.enlarge-container'),
	        callback: function() {
	        	$(".enlarge-hero-container").addClass('visible-hidden');
	    		$(".enlarge-hero-container").css({'height': mainImageHeight+'px'});
	        	enlargeImageEvents.setEnlargeMainImage(largeImg);
	        	$('.enlarge-container').find('ul.swatches').not(".color").closest(".attribute ").remove();
	        	imagesLoaded('.enlarge-right-sec').on('always', function() {
	        		enlargeImageEvents.enlargeHeightCalc();
	        	});
	        	enlargeImageEvents.enlargeHeroSlider();
				enlargeImageEvents.enlargeZoom();
				enlargeImageEvents.rightSectionScrollbar();
				enlargeImageEvents.dialogEvents();
				imagesLoaded('.enlarge-container .product-variation-content').on('always', function() {
	       			image.lazyLoadImages($('.enlarge-container .product-variation-content').find('img'));
				   });
				$('#enlargecontainer').find('.swatchanchor img').unveil(0,variant.pdpSwatchLazyLoad);
				imagesLoaded('.enlarge-hero-container').on('always', function() {
	       			$(".enlarge-hero-container").removeClass('visible-hidden');
	   		    });
	        }
		});
	},
	rightSectionScrollbar: function() {
		$('.apply-scroll-bar').slimScroll({
	        destroy:true
	    });
		$(".apply-scroll-bar").removeAttr("style");
		if( $(window).width() >=768 && $(window).width() <= 1023 ) {
			imagesLoaded('.enlarge-right-sec').on('always', function() {
				if($('.apply-scroll-bar').height() >= 200) {
					$('.apply-scroll-bar').slimScroll({
		                height: '200px',
		                railVisible: true,
		                width: '100%',
		                size: '15px',
		                color: "#aaaaaa",
		                railColor: "#eeeeee",
		                distance: '9px',
		                alwaysVisible: true
		            });
				}
			});
		} else {
			imagesLoaded('.enlarge-right-sec').on('always', function() {
				var rightSecHeight = $(".apply-scroll-bar").height();
				var totalHeight = rightSecHeight + 85;
				if(totalHeight >= 700) {
					$('.apply-scroll-bar').slimScroll({
		                height: rightSecHeight+'px',
		                railVisible: true,
		                size: '15px',
		                color: "#aaaaaa",
		                railColor: "#eeeeee",
		                distance: '9px',
		                alwaysVisible: true
		            });
				}
			});
		}
	},
	enlargeHeroSlider : function() {
		/*var fadeFlag = true;
		if(util.isMobile()) {
			fadeFlag = false;
		}
		$('.enlarge-hero-container').slick({
			  slidesToShow: 1,
			  slidesToScroll: 1,
			  dots: false,
			  fade: fadeFlag,
			  infinite: false,
			  cssEase: 'linear',
			  asNavFor: '.enlarge-thumb-image'
		});
		$('.enlarge-thumb-image').slick({
			  slidesToShow: 5,
			  slidesToScroll: 1,
			  asNavFor: '.enlarge-hero-container',
			  dots: false,
			  infinite: false,
			  arrows: false,
			  focusOnSelect: true
		});
		$('.enlarge-hero-container').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			$("body").find(".zoomWindowContainer, .zoomContainer").remove();
		});
		$('.enlarge-hero-container').on('afterChange', function(event, slick, currentSlide, nextSlide){
		  enlargeImageEvents.enlargeZoom();
		});*/
	},
	enlargeZoom : function() {
		if(util.isMobile()) {
			var $imageContainer = $('.enlarge-hero-image .thumb').first().find('.thumbnail-link');
			imagesLoaded($imageContainer).on('always', function() {
				$imageContainer.each(function () {
					if(!$(this).parent().hasClass('pinch-zoom-container')){
						new RTP.PinchZoom($(this), {});
					}
		        });
			});
	        return;
		}
		else {
			
			$("body").find(".zoomWindowContainer, .zoomContainer").remove();
			var extraClsZoomContainer ="";
			var imageContainer = " .productthumbnail";
			var $imageContainer = $('.enlarge-hero-image .thumb').first().find('.productthumbnail');
			if($("#enlargecontainer").closest(".ui-dialog ").is(":visible")) {
				extraClsZoomContainer = "js-zoom-container";
			}
			imagesLoaded($imageContainer).on('done', function() {
				$imageContainer.elevateZoom({
					responsive: false,
					borderSize: 0,
					loadingIcon: true,
					zoomType: "inner",
					cursor: "default",
					onZoomedImageLoaded: function() {
						$(".zoomContainer").addClass(extraClsZoomContainer);
						//var ipadDialogClose= '<span class="dummy-close-icon"></span><span class="dummy-slick-arrow dummy-slick-prev"></span><span class="dummy-slick-arrow dummy-slick-next"></span> ';
						//$(".zoomContainer").find(".zoomWindowContainer .zoomWindow").append(ipadDialogClose);
					}
				});
    	    });
		}
	},
    init: function () {
        initializeEvents();
    }
};

module.exports = enlargeImageEvents;
